<div mat-dialog-content class="app-confirmation-dialog" id="app-confirmation-dialog" [style.background-color]="settingsData?.event_bg_main_color +'!important'" [style.color]="settingsData?.event_font_main_color +'!important'">
    <div class="fs-16 pt-20 pb-10 text-center fw-500">{{title}}</div>
    <div class="pb-20 text-center" mat-dialog-actions *ngIf="!ok && !isClose">
        <button mat-flat-button (click)="close('yes')" class="flat-primary-button primary-bg-button mt-10 "
        [style.background-color]="settingsData?.event_button_bg_primary_color +'!important'" [style.color]="settingsData?.event_button_font_primary_color +'!important'">
            yes
        </button>
        <button mat-flat-button (click)="close('no')" class="flat-primary-button secondary-bg-btn1 secondary-button-color mt-10"
        [style.background-color]="settingsData?.event_button_bg_secondary_color +'!important'" [style.color]="settingsData?.event_button_font_secondary_color +'!important'">
            No
        </button>
    </div>
    <div class="mt-10 pb-20 text-center" mat-dialog-actions *ngIf="ok">
        <button mat-flat-button (click)="close('yes')" class="flat-primary-button primary-bg-button">
            OK
        </button>
    </div>
    <div class="mt-10 pb-20 text-center" mat-dialog-actions *ngIf="isClose">
        <button mat-flat-button (click)="close('no')" class="flat-primary-button secondary-bg-btn1 secondary-button-color mt-10">
            Close
        </button>
    </div>
</div>